import { openCasinoProviderModal } from "@pages/casino/utils/bettoCasinoEvents";
import chevronRight from "@layouts/betto/assets/chevronRight.svg";
import ProvidersIcon from "@layouts/betto/assets/providersIcon.svg";
import useProvidersController from "@pages/casino/components/ProvidersSlider/useController.js";
import { BettoProviderIcon } from "@layouts/betto/providers/BettoProviderIcon";
import React, { useEffect, useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
	AllButton,
	ArrowButton,
	ArrowIcon,
	Controls,
	HEADER,
	ProviderCard,
	TitleBox,
	Track,
	Viewport,
	WRAPPER,
} from "./elements";

const GAP = 16;

const getVisibleCount = (width) => {
	if (width >= 1440) return 6;
	if (width >= 1024) return 5;
	if (width >= 768) return 4;
	return 2;
};

const selectTranslate = (state) => getTranslate(state.localize);

const BettoProviders = (props) => {
	const translate = useSelector(selectTranslate);
	const {
		state: { providers },
		handlers: { handleSelectProvider },
	} = useProvidersController(props);

	const [visibleCount, setVisibleCount] = useState(() =>
		getVisibleCount(typeof window !== "undefined" ? window.innerWidth : 1440)
	);
	const [index, setIndex] = useState(0);

	const maxIndex = Math.max(0, (providers?.length ?? 0) - visibleCount);

	useEffect(() => {
		const onResize = () => setVisibleCount(getVisibleCount(window.innerWidth));
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	useEffect(() => {
		setIndex((current) => Math.min(current, maxIndex));
	}, [maxIndex]);

	if (!providers?.length) return null;

	const prev = () => setIndex((current) => Math.max(0, current - visibleCount));
	const next = () => setIndex((current) => Math.min(maxIndex, current + visibleCount));

	const seeAll = () => openCasinoProviderModal(props.activeTab);

	const hasNav = maxIndex > 0;

	return (
		<WRAPPER>
			<HEADER>
				<TitleBox>
					<img
						src={ProvidersIcon}
						alt="Providers"
					/>
					{translate("Providers")}
				</TitleBox>
				<Controls>
					{hasNav && (
						<>
							<ArrowButton
								type="button"
								onClick={prev}
								disabled={index <= 0}
								aria-label="Previous">
								<ArrowIcon
									src={chevronRight}
									alt=""
									$mirrored
								/>
							</ArrowButton>
							<ArrowButton
								type="button"
								onClick={next}
								disabled={index >= maxIndex}
								aria-label="Next">
								<ArrowIcon
									src={chevronRight}
									alt=""
								/>
							</ArrowButton>
						</>
					)}
					<AllButton
						type="button"
						onClick={seeAll}>
						{translate("See All")}
					</AllButton>
				</Controls>
			</HEADER>

			<Viewport>
				<Track
					$index={index}
					$count={visibleCount}
					$gap={GAP}>
					{providers.map((provider, i) => (
						<ProviderCard
							key={`betto-provider-${provider}-${i}`}
							$count={visibleCount}
							$gap={GAP}
							onClick={() => handleSelectProvider(provider)}>
							<BettoProviderIcon name={provider} />
						</ProviderCard>
					))}
				</Track>
			</Viewport>
		</WRAPPER>
	);
};

export default withRouter(BettoProviders);
